import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
    template: `<div class="login-spin-div">
      <div class="login-content-div"><nz-spin nzTip="正在登录中······"></nz-spin></div>
    </div>`,
    styleUrls:["./style/jzLogin.css"]
})
export class JZLoginPageComponent implements OnInit {

  constructor(private oauthService: OAuthService) {
  }

  ngOnInit(): void {
    // 登录
    this.oauthService.initLoginFlow();
  }

}